<ccp-data-table [tableConfigs]="tableConfigs" [columns]="columns" [toolbarConfigs]="toolbarConfigs"
     class="table-min-height">
</ccp-data-table>
